module.exports = __webpack_public_path__ + "img/hot_bear_256.f67438d9.png";